<template>
  <div>
    <Modal
      v-model="isShow"
      width="1000"
      height="500"
      :closable="false"
      title="《商户入驻协议》"
    >
      <img
        class="agreement"
        :src="agreement"
      />
      <div slot="footer">
        <Button
          type="success"
          size="large"
          @click="ok()"
        >同意</Button>
        <Button
          size="large"
          @click="cancel()"
        >取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import agreement from './agreement.png'
export default {
  data () {
    return {
      isShow: false,
      agreement
    }
  },
  methods: {
    init () {
      this.isShow = true
    },
    ok () {
      this.$emit('sure')
      this.isShow = false
    },
    cancel () {
      this.isShow = false
    }
  },
}
</script>
<style scoped>
* >>> * {
  font-family: 'Courier New', Courier, monospace !important;
}
.agreement {
  display: block;
  width: 100%;
}
/* * >>> .ivu-icon-ios-close {
  display: none;
} */
</style>


// WEBPACK FOOTER //
// src/components/merchants-entering/pc/agreement.vue